import React from 'react';
import {
  // FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';

const RadioGroupPod = ({ control, label = '', name, defaultValue, options, onChangeradio }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControl component="fieldset">
          {label && <FormLabel component="legend">{label}</FormLabel>}
          <RadioGroup row name={name} value={value}>
            {options.map((item, index) => (
              <FormControlLabel
                key={index}
                value={item.value}
                onChange={(e) => { onChange(e.target.value) , onChangeradio(e.target.value) }}
                control={
                  <Radio
                    color="primary"
                    icon={<RadioButtonIcon />}
                    checkedIcon={<RadioButtonIconFill />}
                  />
                }
                label={item.label}
                labelPlacement={item?.placement || 'top'}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
      defaultValue={defaultValue}
    />
  );
};

export default RadioGroupPod;
